export const httpSuccess = 200;
export const httpBadRequest = 400;
export const unauthorized = 401;


export const success = "0";
export const waitingForOtp = "100";
export const noTurnLeft = "-1006";


// ERROR
export const exception = "-1";
export const error = "-2";



